import { ModalTiteledWindow } from "./modalWindow.js";
import { DateSelect } from "../dateSelect.js";
import { RadioButtons } from "../radiobuttons.js";
import { Validator } from "../validator.js";
import { ModalConfirm } from "./modalConfirm.js";
import { ModalSelectPupil } from "./modalSelectPupil.js";
import { ModalSelectTime } from "./modalSelectTime.js";
import { ModalSpinner } from "./modalSpinner.js";
import { minutesToTime } from '../util.js';
import { NumberSelect } from "../numberSelect.js";

export class ModalEditDayAbsence extends ModalTiteledWindow {
    constructor(app, initData) {
      super();

      this.app = app;
      this.dm = app.dm;
      this.user = this.dm.getUserSelf();

      const defaults = {
         note: '',
         justified: false,
         note: '',
         pupilId: false,
         classId: false,
         absenceType: 'checked',
         absentFrom: 0,
         absentTo: 0
      };

      initData.pupilIds = initData.pupilId ? [initData.pupilId] : [];

      this.initData = Object.extend(true, defaults, initData);

      this.elMain = HTMLElement.createFromHTML(`
         <div class="modal-edit-day-absence">
               <div class="settings-item info">
               </div>
            <div class="settings-item pupil">
               <div class="title absent">Schüler: </div>
               <div class="content">
                  <div class="name"></div>
                  <i class="icon-plus"></i>
                  <div class="validation-error-message"></div>
               </div>
            </div>
            <div class="settings-item absence-type">
               <div class="title"><span>Art der Abwesenheit</span><span class="help icon-info" selector=".day-absence-type"></span></div>
               <div class="content">
                  <div class="validation-error-message"></div>
                  <div class="late-time">
                     <div class="hours">
                           <div class="title">Stunden</div>
                     </div>
                     <div class="minutes">
                           <div class="title">Minuten</div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="settings-item justified">
               <div class="title">Entschuldigt?<span class="help icon-info" selector=".day-absence-justified"></span></div>
               <div class="content">
                  <div class="validation-error-message"></div>
               </div>
            </div>          
            <div class="settings-item date">
               <div class="title"><span>Datum: <span class="date-value"></span></span><span class="help icon-info" selector=".day-absence-date"></span></div>
               <div class="content">
                  <div class="validation-error-message"></div>
               </div>
            </div>

            <div class="settings-item absence-time">
               <div class="title"><span>Uhrzeit</span><span class="help icon-info" selector=".day-absence-time"></span></div>
               <div class="content absent-from">
                  <input id="cbx-absent-from" type="checkbox" class="switch"><label for="cbx-absent-from"></label><label for="cbx-absent-from"><span class="absent-from-day"></span>abwesend ab</label>
                  <div class="time"></div>
               </div>
               <div class="content absent-to">
                  <input id="cbx-absent-to" type="checkbox" class="switch"><label for="cbx-absent-to"></label><label for="cbx-absent-to"><span class="absent-to-day"></span>abwesend bis</label>
                  <div class="time"></div>
               </div>
               </div>
            <div class="settings-item note">
               <div class="title">Bemerkung</div>
               <div class="content">
                  <textarea rows="3" type="text" class="txt-note"></textarea>
               </div>
            </div>
            <div class="buttons bottom-bar">
               <i class="btn-delete icon-trash button-circle"></i>
               <i class="btn-save icon-check button-circle"></i>
            </div>
         </div>
      `);

      // Buttons zum Löschen und Speichern aktivieren / deaktivieren
      /*
      if (this.initData.creatorId === this.user.id || !this.initData.localId) {
         this.elMain.querySelector('.btn-save').onclick = () => this.save();
      }
      else {
         this.elMain.querySelector('.btn-save').style.filter = 'grayscale(1) brightness(1.5)';
      }

      if (this.initData.creatorId === this.user.id && this.initData.localId) {
         this.elMain.querySelector('.btn-delete').onclick = () => this.delete();
      }
      else {
         this.elMain.querySelector('.btn-delete').style.filter = 'grayscale(1) brightness(1.5)';
      }

      if (this.initData.syncStatus === 'update') {
         this.elMain.querySelector('.info .sync-status').classList.add('update');
         this.elMain.querySelector('.info .message').innerHTML = "Dieser Eintrag wurde noch nicht synchronisiert.";
      }
      else if (this.initData.syncStatus === 'error') {
         this.elMain.querySelector('.info .sync-status').classList.add('error');
         this.elMain.querySelector('.info .message').innerHTML = "Fehler beim Synchronisieren: " + this.initData.errorMessage;
      }
      else {
         this.elMain.querySelector('.info').style.display = 'none';
      }
      */

      this.dm.getClass(initData.classId).formTeachers
      let editable = this.initData.creator === undefined
                  || this.initData.creator === this.user.short
                  || this.user.hasPermission('absences', 'edit-all')
                  || (initData.classId && this.dm.getClass(initData.classId).formTeachers.includes(this.user.id));

      this.elMain.querySelector('.btn-save').onclick = () => this.save();

      if (!editable || this.initData.creator === undefined) {
         this.elMain.querySelector('.btn-delete').classList.add('disabled');
      }
      else {
         this.elMain.querySelector('.btn-delete').onclick = () => this.delete();
      }

      // Datum
      this.dateSelect = new DateSelect({ range: true , onSelect: (from, to) => this.setDate(from, to) });
      this.dateSelect.setEnabled(editable);
      this.elMain.querySelector('.settings-item.date .content').prepend(this.dateSelect.getElement());

      this.elAbsentToCbx = this.elMain.querySelector('.settings-item .absent-to input');
      this.elAbsentFromCbx   = this.elMain.querySelector('.settings-item .absent-from input');
      this.elAbsentToTime = this.elMain.querySelector('.settings-item .absent-to .time');
      this.elAbsentFromTime   = this.elMain.querySelector('.settings-item .absent-from .time');

      this.elAbsentToTime.onclick = () => this.setAbsentTime('from', true);
      this.elAbsentFromTime.onclick = () => this.setAbsentTime('to', true);
      this.elAbsentToCbx.onchange = (event) => this.setAbsentTime('from', event.currentTarget.checked, true);
      this.elAbsentFromCbx.onchange = (event) => this.setAbsentTime('to', event.currentTarget.checked, true);

      // Verspätung: Stunden
      this.lateTimeHours = new NumberSelect({
         /*onChange: (hour) => this.setHour(hour),*/
         max: 6,
         columns: 6,
         selectRange: false,
         getNumberTitle: number => number
      });
      this.elMain.querySelector('.late-time .hours').appendChild(this.lateTimeHours.getElement());

      // Verspätung: Minuten
      this.lateTimeMinutes = new NumberSelect({
         /*onChange: (hour) => this.setHour(hour),*/
         max: 12,
         columns: 6,
         selectRange: false,
         getNumberTitle: number => number * 5
      });
      this.elMain.querySelector('.late-time .minutes').appendChild(this.lateTimeMinutes.getElement());


      // Typ
      this.absenceType = new RadioButtons('absenceType',
         { onSelect: (value) => this.setAbsenceType(value) },
         [
               { label: "🎓schulisch",    value: 'school' },
               { label: "☎ abgemeldet",    value: 'checked' },
               { label: "🕑 verspätet",  value: 'late' },
               { label: "❓ vermisst",  value: 'missing' }
         ]
      );
      this.absenceType.setEnabled(editable);
      this.elMain.querySelector('.settings-item.absence-type .content').prepend(this.absenceType.getElement());


      // entschuldigt oder nicht?
      this.justified = new RadioButtons('justified',
         { /*onSelect: (value) => {}*/ },
         [
               { label: "ja",    value: 'ja' },
               { label: "nein",  value: 'nein' }
         ]
      );

      this.elMain.querySelector('.settings-item.justified .content').prepend(this.justified.getElement());

      this.elPupilName = this.elMain.querySelector('.settings-item.pupil .name');
      this.elMain.querySelector('.settings-item.pupil .icon-plus').onclick = () => {
         let pupilIds = this.dm.getClass(this.initData.classId).pupils;
         new ModalSelectPupil({list: pupilIds}, (ids) => this.setPupils(ids), this.dm);
      }

      this.elNote = this.elMain.querySelector('.settings-item.note .txt-note');
      this.elNote.disabled = !editable;

      this.loadData(this.initData);
      this.appendToBody(this.elMain);
      this.setupHelp(this.app);
      setTimeout(() => this.show(), 1);

   }

   save() {

      let val = new Validator([
         {
               name: 'pupilId',
               element: this.elPupilName,                
               get: () => {
                  return this.initData.pupilIds;
               },
               //validate: { 'id': true },
               error: { element: this.elMain.querySelector('.settings-item.pupil .validation-error-message'), message: "Bitte wählen Sie einen Schüler oder eine Schülerin aus." }
         },
         {
               name: 'date',
               element: this.dateSelect.getElement(),
               get: () => {
                  //const d = this.dateSelect.getSelection();
                  //return { from: d.from.isoDate(), to: d.to.isoDate() }
                  return this.dateSelect.getSelection();
               },
               validate: { 'dateRange': true },
               error: { element: this.elMain.querySelector('.settings-item.date .validation-error-message'), message: "Bitte geben Sie das Datum an." }
         },
         {
               name: 'justified',
               element: this.justified.getElement(),
               get: () => this.justified.getValue(),
         },
         {
               name: 'absenceType',
               element: this.absenceType.getElement(),
               get: () => this.absenceType.getValue(),
         },
         {
               name: 'note',
               element: this.elNote,
               get: () => this.elNote.value
         }
      ]);

      let valiData = val.validate();

      if (valiData) {
         valiData.dateFrom = valiData.date.from.isoDate();
         valiData.dateTo   = valiData.date.to.isoDate();
         delete valiData.date;

         valiData.justified = valiData.justified === 'ja';
         valiData.lateTime = this.getLateTime();
         valiData.absentTo = this.initData.absentTo;
         valiData.absentFrom = this.initData.absentFrom;

         let data = Object.extend(true, this.initData, valiData);
         data.creatorType = 'teacher';

         if (data.absenceType === 'late') {
               data.absentFrom = data.absentTo = 0;
         }
         else {
               data.lateTime = 0;
         }

         if (!data.creatorId) data.creatorId = this.user.id;
         data.lastModifierId = this.user.id;

         const promises = data.pupilIds.map((pupilId, index) => {
            const saveData = Object.extend(true, data, { pupilId: pupilId });
            delete saveData.pupilIds;
            if (index > 0) saveData.localId = 0, saveData.id = 0;
            return this.dm.saveDayAbsence(saveData);
         });

         const spinner = new ModalSpinner("Speichere Eintrag");
         Promise.all(promises)
         .then(() => {
            this.app.classReg.redrawBuffer();
            this.close();
         })
         .finally(() => {
            spinner.close();
         });

      }

   }

   delete() {

      new ModalConfirm(
         "Soll dieser Abwesenheitseintrag wirklich gelöscht werden?",
         async (confirmed) => {
               if (confirmed) {
                  await this.dm.deleteDayAbsence(this.initData);
                  this.app.classReg.redrawBuffer();
                  this.close();
               }
         }
      );

   }

   setAbsenceType(value) {
      this.elMain.querySelector('.settings-item.absence-type .late-time').style.maxHeight = value === 'late' ? '15rem' : 0;
      this.elMain.querySelector('.settings-item.absence-time').style.display = value === 'late' ? 'none': 'block';
      this.elMain.querySelector('.settings-item.justified').style.display = value === 'school' ? 'none': 'block';
      if (value === 'late') this.justified.setValue('ja');
   }

   setDate(from, to) {
      const elValue = this.elMain.querySelector('.settings-item.date .title .date-value');
      if (!from) elValue.innerHTML = '';
      else if (to && to.getDate() !== from.getDate()) elValue.innerHTML = Date.simplifyDatePeriod(from.isoDate(), to.isoDate());
      else elValue.innerHTML = from.toGermanDate();

      this.setupAbsenceTimes(from, to);

   }

   setupAbsenceTimes(from, to) {
      const elTime = this.elMain.querySelector('.settings-item.absence-time');
      const elTimeFrom = elTime.querySelector('.content.absent-from');
      const elTimeTo   = elTime.querySelector('.content.absent-to');
      const elToDay   = elTime.querySelector('.absent-to-day');
      const elFromDay = elTime.querySelector('.absent-from-day');

      // nichts markiert
      if (!from && !to) {
         elToDay.innerText = elFromDay.innerText = '';
      }
      // eintägige Abwesenheit
      else if (from && (to === false || from.getDate() === to.getDate())) {
         elToDay.innerText = elFromDay.innerText = '';
         if (elTimeFrom.getIndex() < elTimeTo.getIndex()) {
               elTime.insertBefore(elTimeTo, elTimeFrom);
         }
      }
      // mehrtägige Abwesenheit
      else if (from && to && from.getDate() !== to.getDate()) {
         elFromDay.innerText = ' am ' + from.format('%d.%m') + ' ';
         elToDay.innerText   = ' am ' + to.format('%d.%m') + ' ';
         if (elTimeTo.getIndex() < elTimeFrom.getIndex()) {
               elTime.insertBefore(elTimeFrom, elTimeTo);
         }

      }

   }

   setPupils(pupilIds) {

      //this.initData.pupilIds = [];
      //this.elPupilName.empty();
      for (let pupilId of pupilIds) {
         let pupil = this.dm.getUser(pupilId);
         if (pupil) {
               let elPupil = HTMLElement.createFromHTML(`<div class="pupil"><i class="btn-delete icon-cross"></i><div class="pupil-name">${pupil.lastName}, ${pupil.firstName}</div></div>`);
               this.elPupilName.appendChild(elPupil);
               if (!this.initData.pupilIds.includes(pupilId)) this.initData.pupilIds.push(pupilId);
               elPupil.querySelector('.btn-delete').onclick = (event) => {
                  event.stopPropagation();
                  this.initData.pupilIds = this.initData.pupilIds.filter(id => id !== pupilId);
                  elPupil.remove();
               }
         }
      }

   }

   loadPupils(pupilIds) {

   }

   setLateTime(lateTime) {
      this.lateTimeHours.setSelection(Math.floor(lateTime / 60));
      this.lateTimeMinutes.setSelection(Math.floor((lateTime % 60) / 5));
   }

   setAbsentTime(type, checked, newValue=false) {

      let absentTime = 0;

      if (newValue) {
         const d = new Date();
         absentTime = d.getHours() * 60 + d.getMinutes();
      }
      else {
         if (type === 'from') absentTime = this.initData.absentTo;
         else                 absentTime = this.initData.absentFrom;
      }

      if (checked || (!newValue && absentTime !== 0)) {
         const tp = new ModalSelectTime({
            onSelect: (hour, minute) => {
               if (type === 'from') this.initData.absentTo = hour * 60 + minute;
               else                 this.initData.absentFrom = hour * 60 + minute;
               this.updateAbsentTime();
            },
            initTime: { hour: Math.floor(absentTime / 60), minute: absentTime % 60 }
         });
         tp.show();
      }
      else {
         if (type === 'from') this.initData.absentTo = 0;
         else                 this.initData.absentFrom   = 0;
      }

      this.updateAbsentTime();
   }

   updateAbsentTime() {

      if (this.initData.absentTo === 0) this.elAbsentToTime.innerText = '';
      //else this.elAbsentToTime.innerText = this.formatTime(this.initData.absentTo);
      else this.elAbsentToTime.innerText = minutesToTime(this.initData.absentTo) + ' Uhr';

      if (this.initData.absentFrom === 0) this.elAbsentFromTime.innerText = '';
      else this.elAbsentFromTime.innerText = minutesToTime(this.initData.absentFrom) + ' Uhr';
   }

   /*
   formatTime(minutes) {
      return ('00' + Math.floor(minutes / 60)).slice(-2) + ':' + ('00' + minutes % 60).slice(-2) + ' Uhr';
   }
   */

   getLateTime() {
      if (this.absenceType.getValue() === 'late') {
         return this.lateTimeHours.getSelection() * 60 + this.lateTimeMinutes.getSelection() * 5;
      }
      else {
         return 0;
      }
   }

   getClassList() {
      let classes = Object.values(this.dm.getClasses());

      return {
         list:    classes.filter(cls => !cls.teachers.find(t => t.id === this.user.id)),
         favList: classes.filter(cls => cls.teachers.find(t => t.id === this.user.id)),
      };
   }

   loadData(data) {

      if (data.creationTime) {
         const cTime = new Date(data.creationTime*1000);
         const mTime = new Date(data.lastModTime*1000);
         let info = `erstellt am ${cTime.toGermanDate(true)} um ${cTime.format("%H:%i:%s")} von ${data.creator === 'E' ? 'den Eltern' : data.creator}`
         if (data.creationTime !== data.lastModTime) {
               info += `<br>zuletzt bearbeitet am ${mTime.toGermanDate(true)} um ${mTime.format("%H:%i:%s")} von ${data.lastModifier === 'E' ? 'den Eltern' : data.lastModifier}`;
         }
         /*
         if (data.justificationTime) {
               const jTime = new Date(data.justificationTime*1000);
               info += `<br> Entschuldigung zuletzt bearbeitet am ${jTime.toGermanDate(true)} um ${jTime.format("%H:%i:%s")} von ${data.justifier}`;
         }
         */
         this.elMain.querySelector('.settings-item.info').innerHTML = info;
         if (data.absentTo) {
            this.elAbsentToCbx.checked = true;
         }
         if (data.absentFrom) {
            this.elAbsentFromCbx.checked = true;
         }

         this.updateAbsentTime();


      }

      if (data.pupilId === false) {
         let pupilIds = this.dm.getClass(data.classId).pupils;
         new ModalSelectPupil({list: pupilIds}, (ids) => this.setPupils(ids), this.dm);
      }
      else {
         this.setPupils(data.pupilIds);
      }

      this.dateSelect.select(data.dateFrom ? new Date(Date.fromString(data.dateFrom)) : false, data.dateTo? new Date(Date.fromString(data.dateTo)) : false);
      this.setDate(new Date(Date.fromString(data.dateFrom)), new Date(Date.fromString(data.dateTo)));
      this.elNote.value = data.note;
      this.justified.setValue(data.justified ? 'ja' : 'nein');
      this.absenceType.setValue(data.absenceType || 'checked');
      //this.setAbsenceType(data.absenceType);
      this.setLateTime(data.lateTime || 0);
   }


}

